import styled, { css } from 'react-emotion';

export const Map = styled.div`
	float: right;
	max-width: 315px;
	width: calc(100% - 150px - 2rem);
	
	svg {
		@media (max-width: 480px) {
			display: block;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
		}
		@media (max-width: 515px) {
			max-height: 132px;
		}
	}

	@media (max-width: 480px) {
		margin-left: auto;
		margin-right: auto;
		width: 315px;
		float: none;
	}
`
export const SummaryMap= styled.div`
	max-width: 315px;
	margin-left: auto;
	margin-right: auto;
	
	svg {
		@media (max-width: 480px) {
			display: block;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
		}
		@media (max-width: 515px) {
			max-height: 132px;
		}
	}

	@media (max-width: 480px) {
		margin-left: auto;
		margin-right: auto;
		width: 315px;
		float: none;
	}
`
export const Header = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
`;

export const Total = styled.div`
	color: ${props => props.theme.color};
	font-size: 1rem;
	margin-bottom: 1rem;
	margin-right: 1rem;
	
	@media (max-width: 500px) {
		margin-left: auto;
		margin-right: auto;
	}
`

export const SummaryWithoutLogoTotal = styled.div`
	color: ${props => props.theme.color};
	font-size: 1rem;
	margin-bottom: 1rem;
	margin-right: 1rem;
	
	@media (max-width: 480px) {
		display: block;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
	}
`

export const SummaryButton = css`
	margin: 0 0 1rem;
	cursor: pointer;

	@media (max-width: 500px) {
		margin-left: auto;
		margin-right: auto;
	}
`;

export const SummaryWithoutLogoButton = css`
	margin: 0 0 1rem;
	cursor: pointer;

	@media (max-width: 480px) {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
`;

export const SmartTitle = styled.div`
	font-size: 1.125rem;
	font-weight: bold;
	margin: 0 0 1rem;
	text-align: center;
	width: 100%;

	@media (min-width: 760px) {
		display: none;
	}
`;

export const Schema = styled.div`
	display: flex;
	flex-wrap: nowrap;
`

export const Party = styled.div`
	width: 150px;
	margin-bottom: 0.5rem;

	@media (max-width: 479px) {
		display: flex;
		align-items: center;
		width: auto;
	}
`

export const PartyColumn = styled.div`
	width: 150px;
	margin-bottom: 0.5rem;

	@media (max-width: 480px) {
		display: none;
	}
`

export const Logo = styled.img`
	flex: 0 0 auto;
  display: inline-block;
	margin-right: 0.5rem;
	overflow: hidden;
	vertical-align: middle;
`

export const LineWrap = styled.div`
	flex: 1 0 auto;

	@media (min-width: 480px) {
		display: inline-block;
		vertical-align: middle;
		width: 100px;
	}
`

export const ColumnTitle = styled.div`
	flex: 0 0 auto;
	display: block;
	margin-right: 0.5rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: middle;
	max-width: 100%;
`

export const Line = styled.div`
	box-sizing: border-box;
	color: #fff;
	flex: 1 0 auto;
	font-size: 1.125rem;
	height: 30px;
	line-height: 2rem;
	padding-left: 0.5rem;
`

export const mandates = css`
	font-weight: bold;

	@media (max-width: 500px) {
		flex: 1 0 100%;
		order: 10;
	}
`
